import $http from '../http'
import { baseUrl } from '../url'
const BASEURL = baseUrl.primary + '/V1/Position'

const PositionInfo = {
  PageData(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/PageData`,
      data
    })
  },
  List(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/List`,
      data
    })
  },
    ListProjectPosition(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/ListProjectPosition`,
      data
    })
  },
  ListDistinct(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/ListDistinct`,
      data
    })
  },
  Create(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Create`,
      data
    })
  },
  Detail(params) {
    return $http({
      method: 'get',
      url: `${BASEURL}`,
      params
    })
  },
    ApplyPositionPageData(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/ApplyPositionPageData`,
     data
    })
  },
  Modify(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Modify`,
      data
    })
  },
  SetIsPublic(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/SetIsPublic`,
      data
    })
  },
   Release(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Release`,
      data
    })
  },
   ListNoProjectPosition(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/ListNoProjectPosition`,
      data
    })
  },
  SetReleaseType(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/SetReleaseType`,
      data
    })
  },
  Delete(data) {
    return $http({
      method: 'post',
      url: `${BASEURL}/Delete`,
      data
    })
  },
  Refresh(params) {
    return $http({
      method: 'get',
      url: `${BASEURL}/Refresh`,
      params
    })
  }
}

export default PositionInfo
